<!-- 单元格组容器，替换van-cell-group -->
<template>
  <div :class="groupClass">
    <div
      v-if="title || $slots.title"
      class="px-4 pt-4 pb-2 text-sm text-gray-500 font-medium"
    >
      <slot name="title">{{ title }}</slot>
    </div>
    <div class="bg-white">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  title?: string
  border?: boolean
  inset?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  border: true,
  inset: false
})

const groupClass = computed(() => {
  const baseClasses = ['bg-white', 'overflow-hidden']

  const borderClasses = props.border
    ? ['rounded-xl', 'border', 'border-slate-100']
    : []

  const insetClasses = props.inset ? ['mx-4'] : []

  return [...baseClasses, ...borderClasses, ...insetClasses].join(' ')
})
</script>

<style scoped></style>
